import { Component, OnInit, Output,EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import {OrderByPipe, IsGreaterEqualThanPipe} from 'ngx-pipes';
import{LoopBackAuth, validacionService, pensumService, calificacionService, ActividadService} from '../services/api-rest.service';
import{MessageService} from '../services/message.service';
import { ToastrService } from 'ngx-toastr';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalCausasCalificacionComponent} from '../modal/modal-causas-calificacion/modal-causas-calificacion.component';

@Component({
  selector: 'tabla-calificacion-materia',
  templateUrl: './tabla-calificacion-materia.component.html',
  providers:[OrderByPipe,LoopBackAuth, validacionService,pensumService, calificacionService, ActividadService, MessageService, ]
})
export class TablaCalificacionMateriaComponent implements OnInit, OnChanges {
  @Input() idMatricula
  @Input() esDueno: any
  @Input() tipoAsignatura : any  = 1
  @Input() spinner: any
  @Input() deuda: any
  @Output() emittNivel= new EventEmitter()
  @Output() emittImprimir= new EventEmitter()
  @Input() activarTareas:boolean = true

  search: any
  materias: any
  tareas: any
  arbol:any
  nodo: any
  nivel: any = 0
  public _tablaCalificacion :any
  public _verTablaCalificacion:boolean = false
  public _materia:string =""

  constructor(
    private orderBy: OrderByPipe,
    private ActividadService: ActividadService,
    private calificacionService: calificacionService,
    private pensumService:pensumService,
    public val: validacionService,
    private toastr: ToastrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    console.log("tipoAsignatura ****", this.tipoAsignatura);
  }

  ngOnChanges(changes:SimpleChanges) {
    if(changes.idMatricula != undefined
      && changes.idMatricula.currentValue != undefined)
        this.arbolHorizonta(changes.idMatricula.currentValue)
  }

  modalCausas(calificacion, tarea){
    let idCalificacion = (calificacion.id != null) ? calificacion.id : 0
    const ventana = this.modalService.open(ModalCausasCalificacionComponent,{
      size:'sm'
    })
    ventana.componentInstance.idCalificacion = idCalificacion
    ventana.componentInstance.preview = (this.esDueno ) ? false: true
  }

  imprimirNota(calificacion: any, tarea: any, indice : any){
    if(tarea.nivel == 3 && calificacion.actividad_activa != null){
      let index  = calificacion.actividad_activa.split(",").findIndex(x=> x == indice)
      return  (index >= 0 || tarea.aca_actividad_tipo_id == 3) ? (calificacion.nota == null ) ? 0: calificacion.calificacion_texto :  0
    }else{
      return calificacion.calificacion_texto
    }
  }

  vertareas(tarea:any,calificacion:any, index:number){
    this._verTablaCalificacion = true
    ///if( parseFloat(this.imprimirNota(calificacion,tarea,index))== 0) return null
    console.log(tarea.id,calificacion.aca_docente_asignatura_curso_id,1,this.idMatricula)
    this.calificacionService.tareasCalificacionesPadres(tarea.id,calificacion.aca_docente_asignatura_curso_id,1,this.idMatricula).subscribe(
      result=>{
        console.log("Result --", result)
        //calificacion.tareas = result.sort((x:any,y:any)=> x.orden - y.orden)
        //calificacion.verTabla= true
        this._tablaCalificacion = result.sort((x:any,y:any)=> x.orden - y.orden)
                                        .map((x:any)=>{
                                          x.calificacion = parseFloat(x.calificacion).toFixed(2)
                                          console.log(x.calificacion,"::::P")
                                          return x
                                        })
        this._materia = calificacion.descripcion
      }
    )
  }


  pintarCeldaDesactivada(calificacion : any, tarea : any, indice :any){
    if(tarea.nivel == 3 && calificacion.actividad_activa != null  ){
      let index  = calificacion.actividad_activa.split(",").findIndex((x:any)=> x == indice)
      if(index < 0 && tarea.aca_actividad_tipo_id != 3) return true
    }
    return false
  }



  arbolHorizonta(idMatricula){
    this.spinner.isSpinnerVisible = true

    this.pensumService.asignaturasPensum(idMatricula, this.tipoAsignatura).subscribe(
      materias =>{
        if(materias){
          console.log("Materias PPP ->", materias, idMatricula)
          this.ActividadService.arbolAsignatura(idMatricula, this.tipoAsignatura).subscribe(
            actividades =>{
              if(actividades){
                  this.arbol = this.val.construirArbol(actividades)
                  console.log("Datos de arbol -->", this.arbol)
                  this.calificacionService.calificacionAsignatura(this.idMatricula, this.tipoAsignatura).subscribe(
                    calificaciones =>{
                        if(calificaciones){
                          console.log("calificacion-->", calificaciones.length )
                          this.emittImprimir.emit((calificaciones.length > 0) ? true: false)
                          this.val.construirNotas(this.arbol, materias, calificaciones, 1, 1)

                          this.materias = this.arbol[0].children[0].notas
                          let session = JSON.parse(sessionStorage.getItem('nivel_asignaturas'))
                            if(session == null  || session.nodo == null){
                              this.tareas = this.arbol
                              this.nodo = this.arbol[0]

                            }else if(session.nodo != null){
                              this.siguienteNivel(session.nivel, session.nodo.id)
                            }
                            this.spinner.isSpinnerVisible = false
                        }else{
                          this.spinner.isSpinnerVisible = false
                        }

                    }
                  )
              }else{
                this.spinner.isSpinnerVisible = false
              }
            }
          )

        }
      }
    )
  }

  siguienteNivel(nivel, idNodo){
    this.nivel = nivel

    this.emittNivel.emit(this.nivel)
    this.nodo = this.val.buscarNodo(this.arbol,idNodo,0,nivel)

    let sessionNivel = {
      nivel: this.nivel,
      nodo:this.nodo
    }
    sessionStorage.setItem('nivel_asignaturas', JSON.stringify(sessionNivel))
    this.tareas =  this.orderBy.transform(this.nodo.children,'orden')
}

atrasNivel(){
  this.nivel = this.nivel-1
  this.emittNivel.emit(this.nivel)

  if(this.nivel != 0){
    this.nodo = this.val.buscarNodo(this.arbol,this.nodo.nodoPapa,0,this.nivel)
    this.tareas =  this.orderBy.transform( this.nodo.children,'orden')

    let sessionNivel = {
      nivel: this.nivel,
      nodo:this.nodo
    }
    sessionStorage.setItem('nivel_asignaturas', JSON.stringify(sessionNivel))
  }else{
    let sessionNivel = {
      nivel: 0,
      nodo:null
    }
    sessionStorage.setItem('nivel_asignaturas', JSON.stringify(sessionNivel))
    this.tareas =  this.orderBy.transform( this.arbol,'orden')
  }
}

}



// WEBPACK FOOTER //
// ./src/app/shared/element/tabla-calificacion-materia.component.ts